import { styled } from '@mui/material/styles';
import { MenuItem, Select, Button, TextField } from '@mui/material';
import { DatePicker, DateTimePicker } from '@mui/x-date-pickers';

export const StyledTextField = styled(TextField)`
  border-raduis: 5px;
`;

export const StyledSelect = styled(Select)(({ customWidth }) => ({
  backgroundColor: 'var(--background-color-2)',
  borderRadius: 8,
  width: customWidth || '16ch',
  border: '1px solid var(--border-color)',
  color: 'var(--text-color)',
  '& .MuiSelect-select': {
    backgroundColor: 'transparent !important',
    color: 'var(--text-color) !important',
    padding: '8px',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none !important',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    border: 'none !important',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    border: 'none !important',
  },
  '& .Mui-selected': {
    backgroundColor: 'var(--hover-color) !important',
    color: 'var(--primary-color) !important',
  },
  '& .MuiSelect-icon': {
    color: 'var(--text-color)',
  },
  '&.Mui-disabled': {
    backgroundColor: 'var(--background-color-3)',
    color: 'var(--text-color-light)',
    border: '1px solid var(--border-color)',
  },
  '& .MuiInputBase-root': {
    border: 'none !important',
  },
}));

export const StyledMenuItem = styled(MenuItem)(() => ({
  borderLeft: '1px solid var(--border-color)',
  borderRight: '1px solid var(--border-color)',
  position: 'relative',
  borderBottom: '1px solid var(--border-color)',
  backgroundColor: 'var(--background-color-2) !important',
  color: 'var(--text-color) !important',

  '&:not(.Mui-selected):hover': {
    backgroundColor: 'var(--hover-color) !important',
    color: 'var(--primary-color)',
  },
  '&.Mui-selected': {
    backgroundColor: 'var(--hover-color) !important',
    color: 'var(--primary-color)',
  },
  '&.Mui-selected:hover': {
    backgroundColor: 'var(--hover-color) !important',
    color: 'var(--primary-color)',
  },
  '&:first-of-type': {
    borderTop: '1px solid var(--border-color)',
    borderTopLeftRadius: 5,
    borderTopRightRadius: 5,
  },

  '&:last-of-type': {
    borderBottom: '1px solid var(--border-color)',
    borderBottomLeftRadius: 5,
    borderBottomRightRadius: 5,
  },
}));

export const StyleDatePicker = styled(DatePicker)(({ customWidth }) => ({
  '& .MuiOutlinedInput-root': {
    backgroundColor: 'var(--background-color-2)',
    color: 'var(--text-color)',
    borderRadius: '8px',
    border: '1px solid var(--border-color)',
    transition: 'border-color 0.2s ease',
  },
  '&:hover .MuiOutlinedInput-root': {
    border: '1px solid var(--primary-color)',
  },
  '&.Mui-focused .MuiOutlinedInput-root': {
    border: '2px solid var(--primary-color)',
  },
  '& .MuiOutlinedInput-input': {
    backgroundColor: 'transparent',
    width: customWidth || '12ch',
    padding: '8px',
    color: 'var(--text-color)',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    border: 'none !important',
  },
  '&:hover .MuiOutlinedInput-notchedOutline': {
    border: 'none !important',
  },
  '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
    border: 'none !important',
  },
  '& .MuiInputLabel-root': {
    color: 'var(--text-color-light)',
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: 'var(--primary-color)',
  },
  '& .MuiInputBase-input': {
    color: 'var(--text-color) !important',
  },
  '& .MuiInputBase-input::placeholder': {
    color: 'var(--text-color-light)',
    opacity: 0.7,
  },
  '& .MuiInputAdornment-root': {
    color: 'var(--text-color-light)',
  },
  '& .MuiSvgIcon-root': {
    color: 'var(--text-color-light)',
  },
  '& .MuiOutlinedInput-root.Mui-disabled': {
    backgroundColor: 'var(--background-color-3)',
  },
  '& .MuiOutlinedInput-root.Mui-disabled .MuiInputBase-input': {
    color: 'var(--text-color-light) !important',
    WebkitTextFillColor: 'var(--text-color-light) !important',
  },
  '& .MuiOutlinedInput-root.Mui-disabled .MuiInputAdornment-root': {
    color: 'var(--text-color-light)',
  },
  '& .MuiOutlinedInput-root.Mui-disabled .MuiSvgIcon-root': {
    color: 'var(--text-color-light)',
  },
}));
export const StyleDateTimePicker = styled(DateTimePicker)(
  ({ customWidth }) => ({
    '& .MuiOutlinedInput-root': {
      backgroundColor: 'var(--background-color-2)',
      color: 'var(--text-color)',
      borderRadius: '8px',
      border: '1px solid var(--border-color)',
      transition: 'border-color 0.2s ease',
    },
    '&:hover .MuiOutlinedInput-root': {
      border: '1px solid var(--primary-color)',
    },
    '&.Mui-focused .MuiOutlinedInput-root': {
      border: '2px solid var(--primary-color)',
    },
    '& .MuiOutlinedInput-input': {
      backgroundColor: 'transparent',
      width: customWidth || '16ch',
      padding: '8px',
      color: 'var(--text-color)',
    },
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none !important',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      border: 'none !important',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: 'none !important',
    },
    '& .MuiInputLabel-root': {
      color: 'var(--text-color-light)',
      fontWeight: 'bold',
    },
    '& .MuiInputLabel-root.Mui-focused': {
      color: 'var(--primary-color)',
    },
    '& .MuiInputBase-input': {
      color: 'var(--text-color) !important',
    },
    '& .MuiInputBase-input::placeholder': {
      color: 'var(--text-color-light)',
      opacity: 0.7,
    },
    '& .MuiInputAdornment-root': {
      color: 'var(--text-color-light)',
    },
    '& .MuiSvgIcon-root': {
      color: 'var(--text-color-light)',
    },
    '& .MuiOutlinedInput-root.Mui-disabled': {
      backgroundColor: 'var(--background-color-3)',
      border: '1px solid var(--border-color)',
    },
    '& .MuiOutlinedInput-root.Mui-disabled .MuiInputBase-input': {
      color: 'var(--text-color-light) !important',
      WebkitTextFillColor: 'var(--text-color-light) !important',
    },
    '& .MuiOutlinedInput-root.Mui-disabled .MuiInputAdornment-root': {
      color: 'var(--text-color-light)',
    },
    '& .MuiOutlinedInput-root.Mui-disabled .MuiSvgIcon-root': {
      color: 'var(--text-color-light)',
    },
  })
);

export const StyledButton = styled(Button)(() => ({
  width: '15ch',
  color: 'var(--text-cta)',
  borderRadius: '8px',
  backgroundColor: 'var(--primary-color)',
  marginLeft: '15px',

  '&:hover': {
    backgroundColor: 'var(--hover-color)',
    color: 'var(--primary-color)',
  },
}));
export const StyledRunButton = styled(Button)(() => ({
  width: '15ch',
  height: '4ch',
  color: 'var(--primary-color)',
  borderRadius: '8px',
  border: '2px solid var(--primary-color)',
  backgroundColor: 'var(--background-color-2)',
  marginLeft: '15px',

  '&:hover': {
    backgroundColor: 'var(--hover-color)',
    color: 'var(--primary-color)',
  },
}));
export const StyledGroupButton = styled(Button)(() => ({
  width: '15ch',
  color: 'var(--text-cta)',
  backgroundColor: 'var(--primary-color)',
  border: '1px solid var(--primary-color)',

  //   &:hover {
  //     background-color: #FAC8B2;
  //     color: #FF6A00;
  //   }
  '&:first-of-type': {
    borderTopLeftRadius: '8px',
    borderBottomLeftRadius: '8px',
    borderTopRightRadius: '0px',
    borderBottomRightRadius: '0px',
  },
  '&:last-of-type': {
    borderTopRightRadius: '8px',
    borderBottomRightRadius: '8px',
    borderTopLeftRadius: '0px',
    borderBottomLeftRadius: '0px',
  },
}));
